import { alias, custom, primitive, serializable } from 'serializr';

export class Commodity {
  @serializable(alias('commodity_id', primitive()))
  commodityId?: number;

  @serializable(primitive())
  name?: string;

  @serializable(primitive())
  status?: string;

  @serializable(primitive())
  stage?: number;

  @serializable(primitive())
  farm?: string;

  @serializable(
    custom(
      value => value ?? null,
      value => (typeof value === 'string' ? Number(value) : value)
    )
  )
  emission?: number;

  @serializable(alias('weight', primitive()))
  dryWeight?: string;

  @serializable(alias('created_at', primitive()))
  createdAt?: number;

  @serializable(alias('year', primitive()))
  harvestYear?: number;

  @serializable(alias('image_url', primitive()))
  imageUrl?: string;

  @serializable(alias('livestock_category', primitive()))
  livestockCategory?: string;

  @serializable(alias('revenue_percentage', primitive()))
  revenuePercentage?: number;

  @serializable(alias('mass_allocation', primitive()))
  massAllocation?: number;

  @serializable(alias('type', primitive()))
  commodityType?: string;
}
